import React from "react";
import HomeAbout from "./HomeAbout";
import Services from "./Services";
import Reviews from "./Reviews";
import NavHome from "./NavHome";
import Faq from "./Faq";
import ExpertGuides from "./ExpertGuides";
import UpcomingExpedition from "./UpcomingExpedition";
import PartnerHome from "./PartnerHome";
import Package from "./Package";
import Banner2 from "./Banner2";
import Cta from "./Cta";
import Training from "./Training";
import Slider from "./Hero";

const HomeMain = () => {
  return (
    <>
      <div className=" w-full overflow-hidden">
        <NavHome />
        <div className="hero-container relative h-screen  top-0 left-0 w-full">
         <Slider />
        </div>

        <div className="w-full relative  content-main  bg-white  z-20">
          <div className="md:w-10/12 w-11/12 mx-auto">
            <PartnerHome />
          </div>
          <div className="h-2 mb-8 bg-zinc-200 w-full"></div>

          <HomeAbout />
          <div className="mb-20">
            <Training />
          </div>
          <ExpertGuides />
          <Services />
          <UpcomingExpedition />
          <div className="bg-white">
            <Package />
          </div>
          <Banner2 />

          <div className=" bg-white">
            <Faq />
          </div>

          <div className="bg-white">
            <Reviews />
          </div>

          <div className="lg:w-9/12 w-11/12 mx-auto my-14">
            <Cta />
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeMain;
